import React from 'react';
import { VISIBILITY_BANDS } from '@/utils/visibilityBands';

/** Colour per band. The boundaries and names come from the shared ladder, so this
 *  legend can no longer disagree with what the calendar actually prints. */
const SWATCH: Record<string, string> = {
  'Excellent': 'bg-emerald-600',
  'Very Good': 'bg-green-500',
  'Good': 'bg-lime-400',
  'Fair': 'bg-amber-300',
  'Poor': 'bg-muted/30 border border-border/50',
  'Not Visible': 'bg-muted/30 border border-border/50',
};

export const AnnualHeatmapLegend: React.FC = () => {
  // Poor and Not Visible share a swatch and read as one entry, the way they always have.
  const shown = VISIBILITY_BANDS.filter((b) => b.name !== 'Not Visible');
  return (
    <div className="flex flex-wrap items-center gap-4 p-4 rounded-lg bg-secondary/20 border border-border/50">
      <span className="text-sm font-medium text-foreground">Visibility Rating:</span>
      {shown.map((b) => (
        <div key={b.name} className="flex items-center gap-2">
          <div className={`w-4 h-4 rounded-sm ${SWATCH[b.name]}`} />
          <span className="text-sm text-muted-foreground">
            {b.name === 'Poor' ? 'Poor/None (0-1)' : `${b.name} (${b.range})`}
          </span>
        </div>
      ))}
    </div>
  );
};
